// @flow
/* eslint-env browser */

import { createScrollHandler } from './create-scroll-handler';
import { throttle } from './throttle';

export class CoreService {
    beforeProcessQueue: () => void;

    afterProcessQueue: () => void;

    _trash: any[] = [];

    _queue: any[] = [];

    scrollHandler: any;

    static getInstance(): CoreService {
        window.__ark_ads__ = window.__ark_ads__ || {};
        window.__ark_ads__.coreServiceInstance = window.__ark_ads__.coreServiceInstance || new this();
        return window.__ark_ads__.coreServiceInstance;
    }

    constructor() {
        this.scrollHandler = createScrollHandler(
            this.processQueue,
        );
    }

    queue(elem: any) {
        if (this._trash.filter(ad => ad.adId === elem.adId).length > 0) {
            return;
        }

        this._queue.push(elem);
        this.processQueue();
    }

    dequeue(elem: any) {
        this._trash.push(elem);
        this._queue = this._queue.filter(el => el.adId !== elem.adId);
    }

    onShowGTMEvent(els: string[], isRefresh?: boolean) {
        return { els, isRefresh };
    }

    processQueue = throttle(() => {
        if (this.beforeProcessQueue) {
            this.beforeProcessQueue();
        }
        const toRender = this._queue.filter(el => !el.isRendered() && el.isViewable());
        if (toRender.length > 0) {
            toRender.forEach(el => el.render());
            this.onShowGTMEvent(toRender.map(el => el.adId));
        }
        if (this.afterProcessQueue) {
            this.afterProcessQueue();
        }
    }, 300);
}
